import { type UboResponse, useBoundStore } from '@Store/index';
import { setGA4UserProperties } from '@Services/analytics/analytics.service';
import { processUboFieldValidationErrors } from '@Services/errors/processFieldValidationErrors';

export const getBusinessOwnerData = () => {
  const businessExternalId =
    useBoundStore.getState().customer.customerData.customerBusinessData.externalId;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;

  return { businessExternalId, isEmbedded, customerId };
};

export const syncBusinessUbosToStore = (businessOwners: UboResponse[] | undefined) => {
  const { getCustomerData, setCustomerData } = useBoundStore.getState();
  const customerToUpdate = { ...getCustomerData() };
  customerToUpdate.customerData.customerBusinessData.businessUbos = {
    uboResponseList: businessOwners || [],
  };
  setCustomerData(customerToUpdate);
  setGA4UserProperties();

  if (businessOwners?.length) {
    processUboFieldValidationErrors(businessOwners);
  }
};
